
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NotFound from "./components/NotFound";
import Index from './pages';
import Temp from './pages/temp1';
import Login from './pages/login';
import AdminLogin from './pages/admin';
import SuperAdminLogin from './pages/superAdmin';
import Home from './pages/home';
import Vehicle_details_report from './pages/vehicle_details_report';
import Vehicle_details_report_hire from './pages/vehicle_details_report_hire';
import Vehicle_position_report from './pages/vehicle_position_report';
import Vehicle_position_report_hire from './pages/vehicle_position_report_hire';
import Vehicle_spares_report from './pages/vehicle_spares_report';
import Vehicle_spares_report_hire from './pages/vehicle_spares_report_hire';
import Vehicle_status_report from './pages/vehicle_status_report';
import Vehicle_workinghrs_report from './pages/vehicle_workinghrs_report';
import Vehicle_workinghrs_report_hire from './pages/vehicle_workinghrs_report_hire';
import Vehicle_consume_report from './pages/vehicle_consumereport_list';
import Vehicle_consume_report_hire from './pages/vehicle_consumereport_list_hire';
import Own_vehicle_closed_list from './pages/own_vehicle_closed_list';
import Hire_vehicle_closed_list from './pages/hire_vehicle_closed_list';
import Vehicle_renewal_status from './pages/vehicle_renewal_status';
import Vehicle_renewal_status_hire from './pages/vehicle_renewal_status_hire';
import Vehicle_details_list from './pages/vehicle_details_list';
import Vehicle_position_frame from './pages/vehilce_position_details_frame';
import Vehicle_soldscrab_report from './pages/vehicle_soldscrab_report';
import Tyre_history from './pages/tyreHistory';
import Tyre_currentStatus from './pages/tyre_CurrentStatus';
import Vehicle_currentStatus from './pages/vehicle_currentStatus';
import Vehicle_dieselhrs_report from './pages/vehicle_dieselhrs_report';
import Vehicle_dieselhrs_report_hire from './pages/vehicle_dieselhrs_report_hire';
import Vehicle_dieselkm_report from './pages/vehicle_dieselkms_report';
import Vehicle_dieselkm_report_hire from './pages/vehicle_dieselkms_report_hire';
import Vehicle_dieselmnth_report from './pages/vehicle_dieselmnth_report';
import Vehicle_dieselmnth_report_hire from './pages/vehicle_dieselmnth_report_hire';
import Vehicle_dieselton_report from './pages/vehicle_dieselton_report';
import Vehicle_dieselton_report_hire from './pages/vehicle_dieselton_report_hire';
import Vehicle_transfering_report from './pages/vehicle_transfering_list';
import Renewal_alert from './pages/renewal_alert';
import Vehicle_diesel_report from './pages/vehicle_diesel_report';
import Vehicle_diesel_report_hire from './pages/vehicle_diesel_report_hire';
// janani mam
import Vehicle_maintenance_report from './pages/vehicle_maintenance_report';
import Vehicle_logbook_list from './pages/vehicle_logbook_list';
import Vehicle_logbook_list_hire from './pages/vehicle_logbook_list_hire';
import Own_vehicle_sparesreportlist from './pages/own_vehicle_sparesreportlist';
import Diesel_report from './pages/diesel_report_list';
import Diesel_report_hire from './pages/diesel_report_list_hire';
import Bills_report_list from './pages/bills_report_list';
import Hire_bills_disapproval from './pages/hire_bill_disapproval_list';
import Deliverynote_inward from './pages/deliverynote_inwarded_list';
import Vehicle_maintenance_alert from './pages/vehicle_maintenance_alert';
//Transcation
import Vehicle_maintenance_list from './pages/vehicle_maintenance_list';
import Vehicle_details1 from './pages/vehicle_maintanence_details1'; 
import Vehicle_details_edit from './pages/vehicle_maintanence_details_edit';
import Vehicle_daily_progress_entry from './pages/vehicle_view_add';
import Vehicle_working_hours_own from './pages/vehicle_working_hours_own';
import Vehicle_position_entry from './pages/vehicle_position_entry';
import Vehicle_position_edit from './pages/vehicle_position_edit';
import Vehicle_daily_progress_hire from './pages/vehicle_view_add_hire';
import Vehicle_working_hours_hire from './pages/vehicle_working_hours_hire';
import Vehicle_position_entry_hire from './pages/vehicle_position_entry_hire';
import Vehicle_position_edit_hire from './pages/vehicle_position_hire_edit';
//Tyre Maintenance Details
import Tyre_maintenance from './pages/tyre_maintenance';
import Tyre_add from './pages/tyreadd_vehicle';
//Battery Card Maintenance
import Battery_card_listing from './pages/battery_transaction_view';
import Battery_card_entry from './pages/battery_transaction_entry';
import Battery_card_edit from './pages/battery_transaction_edit';
import Battery_report_view from './pages/battery_report_view';
import Battery_report_entry from './pages/battery_report_entry';
//Hire bill Generation
import Hire_bill_report from './pages/hire_vehicle_bill_report';
import Generate_bill from './pages/generate_bill';
import Generate_bill_add_vehicle from './pages/hire_veh_billdetails';
import Bill_sparesreport from './pages/bill_sparesreport';
//Hire bill Approval - branch
import Branch_bill_approval from './pages/branch_bill_approval';
import Ho_view_bill_approval from './pages/ho_view_bill_approval';
//Hire bill Approval - HO
import Ho_bill_approval from './pages/ho_bill_approval';
//Hire bill approval - Final
import Final_ho_hire_vehicle_report_list1 from './pages/ho_hire_vehicle_report_list1';
//Delivery Note
import DeliveryNote from './pages/deliveryNoteVehicle';
import DeliveryNote_add from './pages/deliveryNote_add';
import Deliverynote_detailsView from './pages/deliverynote_detailsView';
//Delivery Note Inward
import DeliveryNote_inward from './pages/delNoteInwardVehicle';
import Deliverynoteinward_new from './pages/deliverynoteinward_new';
//vehicle close list
import Own_vehicle_list_close from './pages/own_vehicle_list';
import Hire_vehicle_list_close from './pages/hire_vehicle_list';
import Own_vehicle_closing from './pages/own_vehicle_closing';
import Hire_vehicle_closing from './pages/hire_vehicle_closing';
//vehicle Transfer list
import Vehicle_transfer_list from './pages/vehicle_transfer_list';
import Vehicle_details_viewonly from './pages/vehicle_details_viewonly';
import Vehicle_changebranch from './pages/vehicle_changebranch';
import Vehicle_transfer_approval_list from './pages/vehicle_transfer_approval_list';
import Vehicle_transfer_receiving from './pages/vehicle_transfer_receiving';
import Vehicle_transfering_current_status from './pages/vehicle_transfering_current_status';
//Vehicle Costing report
import Own_vehicle_diesel_report_list from './pages/own_vehicle_diesel_report_list';
import Hire_vehicle_diesel_report_list from './pages/hire_vehicle_diesel_report_list';
import Own_diesel_calculation from './pages/own_diesel_calc';
import Hire_diesel_calculation from './pages/diesel_cal';
//Sale and scrap
import Vehicle_sale_and_scrap from './pages/vehicle_sale_and_scrap';
import Vehicle_salescrap from './pages/vehicle_salescrap';
//////////Inventory//////////////
import IntentNoteView from './inventory/indentNoteView';
import AddIndentNote from './inventory/addIndentNote';
import IndentNoteViewSingle from './inventory/indentNoteViewSingle';
import ModifyIndentNote from './inventory/modifyIndentNote';
//Purchase requisition
import PurchasesreqView from './inventory/purchasesreqView';
import Addpr_new from './inventory/addpr_new';
import Viewpr_new from './inventory/viewpr_new';
import PurchasesreqViewapproval from './inventory/purchasesreqViewapproval';
import PrApprovalView_Final from './inventory/prApprovalView_Final';
import Add_PrNew from './inventory/add_PrNew';
import Prview from './inventory/prview';
import PrPurchaseReqviewsingle from './inventory/prPurchaseReqviewsingle';
import Addpriorpurchase_Freight from './inventory/addpriorpurchase_Freight';
import PrApprovalView from './inventory/prApprovalView';
import PrViewSinglePage from './inventory/prViewSingle';
import ComparisionSupplierWithItemViewsingle from './inventory/comparisionSupplierWithItemViewsingle';
import ApprovedPrList from './inventory/approvedPrList';
import RptPrView from './inventory/rptPrView';
import Viewpr_report from './inventory/viewpr_report';
import Prview_report from './inventory/prview_report';
import PrViewSinglereport from './inventory/prViewSinglereport';
import PrPurchaseReq30_print from './inventory/prPurchaseReq30_print';
import Purchasesreqdisapproved from './inventory/purchasesreqdisapproved';
import Viewpr_disapp from './inventory/viewpr_disapp';
import Purchasesreqdisapproved_print from './inventory/purchasesreqdisapproved_print';




//Purchase Order
import PurchaseOrderView from './inventory/purchaseOrderView';
import AddPurchaseOrder from './inventory/addPurchaseOrder';
import PurchaseorderviewSingle from './inventory/purchaseorderviewSingle';
import Purchaseorderpriview from './inventory/purchaseorderpriview';
import PurchaseOrderView_report from './inventory/purchaseOrderView_report'; 
import PurchaseOrderViewSingle_report from './inventory/purchaseOrderViewSingle_report'; 

//GRN
import GRNTransactions from './inventory/grnmenu';
import GrnView from './inventory/grnView';
import AddGrn from './inventory/addGrn';
import GrnInspection from './inventory/grnInspection';
import GrnInspectionViewSingle from './inventory/grnInspectionViewSingle';
import GrnConfirm from './inventory/grnConfirm';
import GrnConfirmViewSingle from './inventory/grnConfirmViewSingle';
import GrnViewSingle from './inventory/grnViewSingle';
import GrnReject from './inventory/grnReject';
import GrnRejectionViewSingle from './inventory/grnRejectionViewSingle';
import AddgrnRejection from './inventory/addgrnRejection';
import Rptgrn from './inventory/rptgrn';
import GrnViewReport from './inventory/grnViewReport';
import GrnViewSingleReport from './inventory/grnViewSingleReport';
import GrnRejectionReport from './inventory/grnRejectionReport';
import GrnRejectionViewSingleReport from './inventory/grnRejectionViewSingleReport';




//bill passing Menu - HO
import Billpassingmenu from './inventory/billpassingmenu';
import BillPassingGRNView from './inventory/billPassingGRNView';
import BillpassingGrnViewSingle from './inventory/billpassingGrnViewSingle';
import Billpassingview from './inventory/billpassingview';
import BillPassingGrnRejectionView from './inventory/billPassingGrnRejectionView';
import Billpassinggrnrejview from './inventory/billpassinggrnrejview';
//Branch office store req
import Mis_prview from './inventory/mis_prview';
import Mis_AddPr from './inventory/mis_AddPr';
import Mis_PrViewSingle from './inventory/mis_PrViewSingle';
import Mis_ModifyPr from './inventory/mis_ModifyPr';
//Branch Office Purchase Order
import MiscPoView from './inventory/miscPoView';
import MiscPOViewSingle from './inventory/miscPOViewSingle';
import MiscPoView_print from './inventory/miscPoView_print';
import AddMiscPO from './inventory/addMiscPO';
import MiscPOViewSingle_report from './inventory/miscPOViewSingle_report';
import Miscpo_report from './inventory/miscpo_report'; 

//Misc GRN
import Miscgrnmenu from './inventory/miscgrnmenu';
import MiscGrnView from './inventory/miscGrnView';
import AddMiscGrn from './inventory/addMiscGrn';
import MiscGrnViewSingle from './inventory/miscGrnViewSingle';
import MiscGrnInspection from './inventory/miscGrnInspection';
import MiscGrnInspectionViewSingle from './inventory/miscGrnInspectionViewSingle';
import MiscgrnRejectionView from './inventory/miscgrnRejectionView';
import AddMiscGrnRejection from './inventory/addMiscGrnRejection';
import MiscGrnRejectionViewSingle from './inventory/miscGrnRejectionViewSingle';
//Misc Bill Passing menu
import Miscbillpassingmenu from './inventory/miscbillpassingmenu';
import MiscBillPassingGRNView from './inventory/miscBillPassingGRNView';
import AddbillpassingMiscGrn from './inventory/addbillpassingMiscGrn';
import Billpassingmiscview from './inventory/billpassingmiscview';
import MiscBillPassingGrnRejectionView from './inventory/miscBillPassingGrnRejectionView';
//Delivery Note - inventory
import DelNoteInventory from './inventory/delNoteInventory';
import DeliveryNote_add_in from './inventory/deliveryNote_add_in';
import Deliverynoteinward_in from './inventory/deliverynoteinward_in';
//Delivery Note Inward - inventory
import Deliveryinwardnote_in from './inventory/deliveryinwardnote_in';
import DeliveryNoteInwardReport from './inventory/deliveryNoteInwardReport';
import Deliverynote_inwardedviewReport from './inventory/deliverynote_inwardedviewReport';
import Deliveryinwardnote_print from './inventory/deliveryinwardnote_print';



//Delivery CHallan
import DcView from './inventory/dcView';
import AddDc from './inventory/addDc';
import DcViewSingle from './inventory/dcViewSingle';
import DcPrint from './inventory/dcPrint';
import DcReturnView from './inventory/dcReturnView';
import AddDcReturn from './inventory/addDcReturn';
import DcReturnViewSingle from './inventory/dcReturnViewSingle';
import DcReturnPrint from './inventory/dcReturnPrint';
import RptDCpendingView from './inventory/rptDCpendingView';
import DcNonReturn from './inventory/dcNonReturn';


//STN
import StnView from './inventory/stn_view';
import StnViewSingle from './inventory/viewstn';
import Addstn from './inventory/addstn';
import Addstn_edit from './inventory/addstn_edit';
import Stn_approvalview from './inventory/stn_approvalview';
import Viewstn_newapproval from './inventory/viewstn_newapproval';
import Addstn_neweditapproval from './inventory/addstn_neweditapproval';
import Stn_disApprovalview from './inventory/stn_disApprovalview';
import StnDisApproveView from './inventory/stnDisApproveView';
import StockTransferNotependingView from './inventory/stockTransferNotependingView';
import StnInward from './inventory/stnInward';
import StnViewpendingSingle from './inventory/stnViewpendingSingle';
import StnViewPendingSingle_report from './inventory/stnViewPendingSingle_report';
import StnReport_print from './inventory/stnReport_print';
import StnOutward_report from './inventory/stnOutward_report';
import StnViewOutwardSingle_report from './inventory/stnViewOutwardSingle_report';
import Stn_outwardreport_print from './inventory/stn_outwardreport_print';
import Stn_inward_reject from './inventory/stn_inward_reject';
import Stn_inward_rejectView from './inventory/stn_inward_rejectView';
import StockTransferNoteView from './inventory/stockTransferNoteView';
import AddStockTransferNote from './inventory/addStockTransferNote';
import StnOutwardViewSingle from './inventory/stnViewSingle';
import StnViewpendingSinglePrint from './inventory/stnViewpendingSinglePrint';
import StockTransferNoteView_new from './inventory/stockTransferNoteView_new';
import AddStockTransferNote_new from './inventory/addStockTransferNote_new';
import StockTransferNote_report from './inventory/stockTransferNote_report';
import StnRequisitionReport from './inventory/stnRequisitionReport';
import Viewstn_report from './inventory/viewstn_report';
//Store Issue
import SfIssuesView from './inventory/sfIssuesView';
import AddSFissues from './inventory/addSFissues';
import SfIssuesViewSingle from './inventory/sfIssuesViewSingle';
//Store Receipt
import SfReceiptsView from './inventory/sfReceiptsView';
import AddSFReceipts from './inventory/addSFReceipts';
import ModifySfReceipt from './inventory/modifySfReceipt';
import SfReceiptsViewSingle from './inventory/sfReceiptsViewSingle';
//Item Rate Comparision
import ItemMasterViewcomparision from './inventory/itemMasterViewcomparision';
import ComparisionSupplierWithItemView from './inventory/comparisionSupplierWithItemView';
//View Heading
import Viewheading from './inventory/viewheading';
import Viewsubheading from './inventory/viewsubheading';
import View_innersubheading from './inventory/view_innersubheading';
import View_Filelisting from './inventory/view_Filelisting';
//Master Module
//Item Code generation
import Add_Item_Category from './inventory/add_Item_Category';
import Add_Item_Subcategory from './inventory/add_Item_Subcategory';
import Add_Inner_Subcategory from './inventory/add_Inner_Subcategory';
import Add_deep_Inner_Subcategory from './inventory/add_deep_Inner_Subcategory';
import Add_deep_Inner_Item_Subcategory from './inventory/add_deep_Inner_Item_Subcategory';
//Item
import Itemmasterviewnew from './inventory/itemmasterviewnew';
import AddNewItem from './inventory/addNewItem';
import Modifyitem from './inventory/modifyitem';
import List_Itemserialnumber from './inventory/list_Itemserialnumber';
import ItemTreeView from './inventory/materialclassification';
import StockSummary from './inventory/stock';
import RptItemMasterView from './inventory/rptItemMasterView';
//Supplier With Item
import SupplierMasterView from './inventory/supplierMasterView';
import AddModifier from './inventory/addModifier';
import AddNewSupplierWithItem from './inventory/addNewSupplierWithItem';
import SupplierWIsubassembly from './inventory/supplierWIsubassembly';
import SupplierWithItemVIew from './inventory/supplierWithItemVIew';
import ModifySupplierWithItem from './inventory/modifySupplierWithItem';
import ModifySupplier from './inventory/modifySupplier';
import ModifySupplierView from './inventory/modifySupplierView';
import SupplierMasterViewReport from './inventory/supplierMasterViewReport';
import ModifySupplierViewReport from './inventory/modifySupplierViewReport';
import SupplierDetailPrint from './inventory/supplierDetailPrint';
import RptSupplierWithItemView from './inventory/rptSupplierWithItemView';
//Department Master 
import DepartmentMaster from './inventory/departmentMasterView';
import TransportMasterView from './inventory/transportMasterView';
import Subdepartment from './inventory/subdepartment';
import UomMasterView from './inventory/uomMasterView';
//Vendor Rating
import VendorControlRatingMenu from './inventory/vendorControlRatingMenu';
import RptVCRqualityGrn from './inventory/rptVCRqualityGrn';
import RptVCRDeliveryGrn from './inventory/rptVCRDeliveryGrn';
import RptSupplierRatingGrn from './inventory/rptSupplierRatingGrn';

/////////////Admin
import Admin_members_list from './admin/admin_members_list';
import Admin_members_add from './admin/admin_members_add';
import Admin_members_edit from './admin/admin_members_edit';
import Admin_members_approval from './admin/admin_members_approval';
/////Category
import Staff_category_list from './admin/staff_category_list';
/////Flash News
import Flashnewslist from './admin/flashnewslist';
import FlashNewsEntry from './admin/flashNewsEntry';
import FlashNewsEdit from './admin/flashNewsEdit';
//File Heading
import Add_fileheading from './admin/add_fileheading';
import Add_filesubheading from './admin/add_filesubheading';
import Add_filesubheadingsecond from './admin/add_filesubheadingsecond';
//Branch Master-admin
import BranchMasterViewAdmin from './admin/branchMasterView';
//Admin Menu
import Admin_Menu from './admin/admin_Menu';
import Admin_menu_add from './admin/admin_menu_add';
import Admin_Menu_edit from './admin/admin_Menu_edit';
import Admin_Menu_orders from './admin/menu_orders';



//Admin Register /////////////////////////////////////////////////////////////////Add new update//////////////////////////////
import FileManager from './admin/admin_filemanager';
import FileListing from './admin/file_listing';
import AddNewFile from './admin/add_newfile';
import File_Edit from './admin/file_edit';
import Cd from './admin/cd';

//Admin Register /////////////////////////////////////////////////////////////////Add new update//////////////////////////////


import Deliverynote_detailsView_in from './inventory/deliverynote_detailsView_in';


import Vehicle_Own_Name from './pages/vehicle_namemaster';
import Vehicle_details_View from './pages/vehicle_details_view';
import Vehicle_details_edit1 from './pages/vehicle_details_edit';
import AddOwnVeh from './pages/add_own_veh_reg';
import Vehicle_typemaster from './pages/vehicle_typemaster';
import VehicleTypeMaintenance from './pages/vehicle_type_maintenance_listing';
import Vehicletype_subassembly from './pages/vehicletype_subassembly';
import Vehicle_Main_Entry from './pages/vehicletype_maintenace_Entry';
import VehRateMas from './pages/vehicle_ratemaster';
import Editratemaster from './pages/edit_veh_rate_master';
import VehSparePercentMaster from './pages/vehicle_sparspercentagemaster_listing';
import AddSparePrecent from './pages/add_spare_percent';
import EditSparePercent from './pages/edit_spare_percent';
import HireMaster from './pages/hire_vehicle_registration_listing';
import AddHireVehicle from './pages/add_hire_vehicle';
import Hire_vehicle_view from './pages/view_hire_vehicle';
import Hire_vehicle_edit from './pages/edit_hire_vehicle';
import Equipmaster from './pages/equip_master_listing';
import Tyremaster from './pages/tyrelisting';
import AddTyre from './pages/add_tyre';
import ViewTyre from './pages/view_tyre';
import EditTyre from './pages/edit_tyre';
import BatteryCard from './pages/battery_card_listing';
import AddBatteryCard from './pages/add_batterycard';
import EditBatterycard from './pages/edit_batterycard';
import VehicleLocationListing from './pages/vehicle_locationmaster_listing';


// Report - New
import Vehicle_maintenance_details_report from './pages/vehicle_maintanence_details1_report';
import OwnVehReport from './pages/own_vehicle_report';
import HireVehReport from './pages/hire_vehicle_report';
import OwnVehSparesReport from './pages/own_vehicle_sparesreport';
import HireVehSparesReport from './pages/hire_vehicle_sparesreport';
import OwnVehicleConRep from './pages/own_vehicleconsume_report';
import HireVehicleConRep from './pages/hire_vehicleconsume_report';
import ViewHireVehicle from './pages/hire_vehicle_details_view_report_list';
import OwnVehiclePostion from './pages/own_vehicle_position_history';
import Vehicle_maintenance_history from './pages/vehicle_maintanence_history';
import Vehicle_Transferring_history from './pages/vehicle_transfering_history_view';
import OwnReport_log_book from './pages/report';
import HireVehiclePostion from './pages/hire_vehicle_position_history';
import HireReport_log_book from './pages/report1';
import Vehicle_diesel_report_view from './pages/vehicle_diesel_report_view';
import Hire_Vehicle_diesel_report_view from './pages/vehicle_diesel_report_view_hire';
import VehicleBillReport from './pages/ho_view_bill_report';
import Hire_charges_bill_new from './pages/hire_charges_bill_new';
import Ho_view_bill from './pages/ho_view_bill';
import Vehicle_salescrap_view from './pages/vehicle_salescrap_view';
import Tyrevehiclesearch from './pages/tyrevehiclesearch';
import Tyrevehiclesearch1 from './pages/tyrevehiclesearch1';
import Tyrehistory_view from './pages/tyrehistory_view';
import TyreHistory_Print from './pages/tyreHistory_Print';
import DelVehPrint from './pages/deliverynote_inwardedview';
import Veh_transfer_history_report from './pages/vehicle_transfering_history_report';
import Vehicle_maintenance_alert_detail from './pages/vehicle_maintenance_alert_detail';
import HireTotalBill from './pages/hire_total_bill';

import DieselMaster from './pages/vehicle_dieselrate_listing';
import AddDieselrate from './pages/add_dieselrate';
import EditDieselRate from './pages/edit_dieselrate';

import Vehicle_closed_view from './pages/vehicle_closed_view';

import FlashNews from './components/flashNews';
import Welcome from './pages/welcome';







function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
        <Route index="/index" element={<Index />} />
        <Route path="/temp1" element={<Temp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/home" element={<Home />} />

<Route path="/welcome" element={<Welcome />} />
        <Route path="/components/flashNews" element={<FlashNews />} />

        <Route path="/inventory/deliverynote_detailsView_in/:delNo" element={<Deliverynote_detailsView_in />} />

        
         {/* master module - janani mam */}
         <Route path="/vehicle_namemaster" element={<Vehicle_Own_Name />} />
        <Route path="/vehicle_details_view/:sno" element={<Vehicle_details_View />} />
        <Route path="/vehicle_details_edit/:sno" element={<Vehicle_details_edit1 />} />
        <Route path="/add_own_veh_reg/:id" element={<AddOwnVeh />} />
        <Route path="/vehicle_typemaster" element={<Vehicle_typemaster />} />
        <Route path="/vehicle_type_maintenance_listing" element={<VehicleTypeMaintenance />} />
        <Route path="/vehicletype_subassembly/:id" element={<Vehicletype_subassembly />} />
        <Route path="/vehicletype_maintenace_Entry/:id" element={<Vehicle_Main_Entry />} />
        <Route path="/vehicle_ratemaster" element={<VehRateMas />} />
        <Route path="/edit_veh_rate_master/:id" element={<Editratemaster />} />
        <Route path="/hire_vehicle_registration_listing" element={<HireMaster />} />  
        <Route path="/add_hire_vehicle" element={<AddHireVehicle />} />  
        <Route path="/view_hire_vehicle/:id/:branchCode" element={<Hire_vehicle_view />} />  
        <Route path="/edit_hire_vehicle/:id/:branchCode" element={<Hire_vehicle_edit />} />  
        <Route path="/equip_master_listing" element={<Equipmaster />} />  
        <Route path="/tyrelisting" element={<Tyremaster />} />  
        <Route path="/add_tyre" element={<AddTyre />} />  
        <Route path="/view_tyre/:id" element={<ViewTyre />} />  
        <Route path="/edit_tyre/:id" element={<EditTyre />} />  
        <Route path="/battery_card_listing" element={<BatteryCard />} />  
        <Route path="/add_batterycard" element={<AddBatteryCard />} />  
        <Route path="/edit_batterycard/:id" element={<EditBatterycard />} />  
        <Route path="/vehicle_locationmaster_listing" element={<VehicleLocationListing />} /> 
        <Route path="/vehicle_sparspercentagemaster_listing" element={<VehSparePercentMaster />} />  
        <Route path="/add_spare_percent" element={<AddSparePrecent />} />  
        <Route path="/edit_spare_percent/:id" element={<EditSparePercent />} />  
        <Route path="/equip_master_listing" element={<Equipmaster />} />  

        <Route path="/vehicle_closed_view/:sno" element={<Vehicle_closed_view />} />

        {/* Report - New */}
      <Route path="/vehicle_maintanence_details1_report/:id/:branch" element={<Vehicle_maintenance_details_report />} />  
      <Route path="/own_vehicle_report/:id/:branch/:basis" element={<OwnVehReport/>} />  
      <Route path="/hire_vehicle_report/:id/:branch/:basis" element={<HireVehReport/>} />  
      <Route path="/own_vehicle_sparesreport/:id" element={<OwnVehSparesReport/>} /> 
      <Route path="/hire_vehicle_sparesreport/:id" element={<HireVehSparesReport/>} /> 
      <Route path="/own_vehicleconsume_report/:id/:branch" element={<OwnVehicleConRep />} />  
      <Route path="/hire_vehicleconsume_report/:id/:branch" element={<HireVehicleConRep />} />  
      <Route path="/hire_vehicle_details_view_report_list/:id/:branch" element={<ViewHireVehicle />} />  
      <Route path="/own_vehicle_position_history/:id/:branch" element={<OwnVehiclePostion />} />  
      <Route path="/vehicle_maintanence_history/:id/:branch" element={<Vehicle_maintenance_history />} />  
      <Route path="/vehicle_transfering_history_view/:id/:branch" element={<Vehicle_Transferring_history />} />  
      <Route path="/report/:id/:branch" element={<OwnReport_log_book />} />  
      <Route path="/hire_vehicle_position_history/:id/:branch/:basis" element={<HireVehiclePostion />} />  
      <Route path="/report1/:id/:branch" element={<HireReport_log_book />} />  
      <Route path="/vehicle_diesel_report_view/:id/:branch" element={<Vehicle_diesel_report_view />} />  
      <Route path="/vehicle_diesel_report_view_hire/:id/:branch" element={<Hire_Vehicle_diesel_report_view />} />
      <Route path="/ho_view_bill_report/:id/:branch/:billno" element={<VehicleBillReport />} />  
      <Route path="/hire_charges_bill_new/:id/:billNo/:branch/:vcode" element={<Hire_charges_bill_new />} />  
      <Route path="/ho_view_bill/:id/:branch" element={<Ho_view_bill />} />
      <Route path="/vehicle_salescrap_view/:id" element={<Vehicle_salescrap_view />} />
      <Route path="/tyrevehiclesearch/:id/:branch" element={<Tyrevehiclesearch />} />
      <Route path="/tyrevehiclesearch1/:id" element={<Tyrevehiclesearch1 />} />
      <Route path="/tyrehistory_view/:id" element={<Tyrehistory_view />} />
      <Route path="/tyreHistory_Print/:id" element={<TyreHistory_Print />} />
      <Route path="/deliverynote_inwardedview/:delNo" element={<DelVehPrint />} />
      <Route path="/vehicle_transfering_history_report/:id" element={<Veh_transfer_history_report />} />
      <Route path="/Vehicle_maintenance_alert_detail/:id/:branch" element={<Vehicle_maintenance_alert_detail />} />
      <Route path="/hire_total_bill/:id/:billNo/:branch/:vcode" element={<HireTotalBill />} />
      
 <Route path="/vehicle_dieselrate_listing" element={<DieselMaster />} />
      <Route path="/add_dieselrate" element={<AddDieselrate />} />
      <Route path="/edit_dieselrate/:id" element={<EditDieselRate />} /> 
      



        <Route path="/vehicle_details_report" element={<Vehicle_details_report />} />
        <Route path="/vehicle_details_report_hire" element={<Vehicle_details_report_hire />} />
        <Route path="/vehicle_position_report" element={<Vehicle_position_report />} />
        <Route path="/vehicle_position_report_hire" element={<Vehicle_position_report_hire />} />
        <Route path="/vehicle_spares_report" element={<Vehicle_spares_report />} />
        <Route path="/vehicle_spares_report_hire" element={<Vehicle_spares_report_hire />} />
        <Route path="/vehicle_status_report" element={<Vehicle_status_report />} />
        <Route path="/vehicle_workinghrs_report" element={<Vehicle_workinghrs_report />} />
        <Route path="/vehicle_workinghrs_report_hire" element={<Vehicle_workinghrs_report_hire />} />
        <Route path="/vehicle_consumereport_list" element={<Vehicle_consume_report />} />
        <Route path="/vehicle_consumereport_list_hire" element={<Vehicle_consume_report_hire />} />
        <Route path="/own_vehicle_closed_list" element={<Own_vehicle_closed_list />} />
        <Route path="/hire_vehicle_closed_list" element={<Hire_vehicle_closed_list />} />
        <Route path="/vehicle_renewal_status" element={<Vehicle_renewal_status />} />
        <Route path="/vehicle_renewal_status_hire" element={<Vehicle_renewal_status_hire />} />
        <Route path="/vehicle_details_list" element={<Vehicle_details_list />} />
        <Route path="/vehilce_position_details_frame" element={<Vehicle_position_frame />} />
        <Route path="/vehicle_soldscrab_report" element={<Vehicle_soldscrab_report />} />
        <Route path="/tyreHistory" element={<Tyre_history />} />
        <Route path="/tyre_CurrentStatus" element={<Tyre_currentStatus />} />
        <Route path="/vehicle_currentStatus" element={<Vehicle_currentStatus />} />
        <Route path="/vehicle_dieselhrs_report" element={<Vehicle_dieselhrs_report />} />
        <Route path="/vehicle_dieselhrs_report_hire" element={<Vehicle_dieselhrs_report_hire />} />
        <Route path="/vehicle_dieselkms_report" element={<Vehicle_dieselkm_report />} />
        <Route path="/vehicle_dieselkms_report_hire" element={<Vehicle_dieselkm_report_hire />} />
        <Route path="/vehicle_dieselmnth_report" element={<Vehicle_dieselmnth_report />} />
        <Route path="/vehicle_dieselmnth_report_hire" element={<Vehicle_dieselmnth_report_hire />} />
        <Route path="/vehicle_dieselton_report" element={<Vehicle_dieselton_report />} />
        <Route path="/vehicle_dieselton_report_hire" element={<Vehicle_dieselton_report_hire />} />
        <Route path="/vehicle_transfering_list" element={<Vehicle_transfering_report />} />
        <Route path="/renewal_alert" element={<Renewal_alert />} />
        <Route path="/vehicle_diesel_report" element={<Vehicle_diesel_report />} />
        <Route path="/vehicle_diesel_report_hire" element={<Vehicle_diesel_report_hire />} /> 
        {/* janani mam */}
        <Route path="/vehicle_maintenance_report" element={<Vehicle_maintenance_report />} />
        <Route path="/vehicle_logbook_list" element={<Vehicle_logbook_list />} />
        <Route path="/vehicle_logbook_list_hire" element={<Vehicle_logbook_list_hire />} />
        <Route path="/own_vehicle_sparesreportlist" element={<Own_vehicle_sparesreportlist />} />
        <Route path="/diesel_report_list" element={<Diesel_report />} />
        <Route path="/diesel_report_list_hire" element={<Diesel_report_hire />} />
        <Route path="/bills_report_list" element={<Bills_report_list />} />
        <Route path="/hire_bill_disapproval_list" element={<Hire_bills_disapproval />} />
        <Route path="/deliverynote_inwarded_list" element={<Deliverynote_inward />} />
        <Route path="/vehicle_maintenance_alert" element={<Vehicle_maintenance_alert />} /> 
        {/* Transcation */}
        <Route path="/vehicle_maintenance_list" element={<Vehicle_maintenance_list />} /> 
        <Route path="/vehicle_maintanence_details1/:vcode/:basis" element={<Vehicle_details1 />} />
        <Route path="/vehicle_maintanence_details_edit/:sno/:vcode/:branch" element={<Vehicle_details_edit />} />
        <Route path="/vehicle_view_add" element={<Vehicle_daily_progress_entry />} />
        <Route path="/vehicle_working_hours_own/:vcode/:vehno/:vehname/:branch/:basis" element={<Vehicle_working_hours_own />} />
        <Route path="/vehicle_position_entry/:vcode/:vehno/:vehname/:branch" element={<Vehicle_position_entry />} />
        <Route path="/vehicle_position_edit/:id/:vcode/:vehno/:vehname/:branch" element={<Vehicle_position_edit />} />
        <Route path="/vehicle_view_add_hire" element={<Vehicle_daily_progress_hire />} />
        <Route path="/vehicle_working_hours_hire/:basis/:vtype/:vcode/:vehno/:vehname/:branch" element={<Vehicle_working_hours_hire />} />
        <Route path="/vehicle_position_entry_hire/:basis/:vtype/:vcode/:vehno/:vehname/:branch" element={<Vehicle_position_entry_hire />} />
        <Route path="/vehicle_position_hire_edit/:id/:basis/:vtype/:vcode/:vehno/:vehname/:branch" element={<Vehicle_position_edit_hire />} />
        {/* //Tyre Maintenance Details */}
        <Route path="/tyre_maintenance" element={<Tyre_maintenance />} />
        <Route path="/tyreadd_vehicle/:basis/:vcode/:branch" element={<Tyre_add />} />
        {/* //Battery Card Maintenance */}
        <Route path="/battery_transaction_view" element={<Battery_card_listing />} />
        <Route path="/battery_transaction_entry" element={<Battery_card_entry />} />
        <Route path="/battery_transaction_edit/:id" element={<Battery_card_edit />} />
        <Route path="/battery_report_view/:id" element={<Battery_report_view />} />
        <Route path="/battery_report_entry/:id" element={<Battery_report_entry />} />
        {/* //Hire bill Generation */}
        <Route path="/hire_vehicle_bill_report" element={<Hire_bill_report />} />
        <Route path="/generate_bill/:vcode/:basis" element={<Generate_bill />} />
        <Route path="/hire_veh_billdetails/:vcode/:billNo/:basis" element={<Generate_bill_add_vehicle />} />
        <Route path="/bill_sparesreport/:vcode/:billNo/:basis" element={<Bill_sparesreport />} />
        {/* Branch bill approval */}
        <Route path="/branch_bill_approval" element={<Branch_bill_approval />} />
        <Route path="/ho_view_bill_approval/:id/:branch" element={<Ho_view_bill_approval />} />
        {/* HO bill approval */}
        <Route path="/ho_bill_approval" element={<Ho_bill_approval />} />
        {/* Final Approval */}
        <Route path="/ho_hire_vehicle_report_list1" element={<Final_ho_hire_vehicle_report_list1 />} />
        {/* Delivery Note */}
        <Route path="/deliveryNoteVehicle" element={<DeliveryNote />} />
        <Route path="/deliveryNote_add" element={<DeliveryNote_add />} />
        <Route path="/deliverynote_detailsView/:delNo" element={<Deliverynote_detailsView />} />
        {/* Delivery Note Inward*/}
        <Route path="/delNoteInwardVehicle" element={<DeliveryNote_inward />} />
        <Route path="/deliverynoteinward_new/:delNo" element={<Deliverynoteinward_new />} />
        
         {/* close vehicle*/}
         <Route path="/own_vehicle_list" element={<Own_vehicle_list_close />} />
        <Route path="/hire_vehicle_list" element={<Hire_vehicle_list_close />} />
        <Route path="/own_vehicle_closing/:sno" element={<Own_vehicle_closing />} />
        <Route path="/hire_vehicle_closing/:sno" element={<Hire_vehicle_closing />} />
        {/* vehicle Transfer list*/}
        <Route path="/vehicle_transfer_list" element={<Vehicle_transfer_list />} />
        <Route path="/vehicle_details_viewonly/:sno" element={<Vehicle_details_viewonly />} />
        <Route path="/vehicle_changebranch/:sno" element={<Vehicle_changebranch />} />
        <Route path="/vehicle_transfer_approval_list" element={<Vehicle_transfer_approval_list />} />
        <Route path="/vehicle_transfer_receiving" element={<Vehicle_transfer_receiving />} />
        <Route path="/vehicle_transfering_current_status" element={<Vehicle_transfering_current_status />} />
        {/* vehicle costing report */}
        <Route path="/own_vehicle_diesel_report_list" element={<Own_vehicle_diesel_report_list />} />
        <Route path="/hire_vehicle_diesel_report_list" element={<Hire_vehicle_diesel_report_list />} />
        <Route path="/own_diesel_calc/:vcode/:branch/:basis" element={<Own_diesel_calculation />} />
        <Route path="/diesel_cal/:vcode/:branch/:basis" element={<Hire_diesel_calculation />} />
        {/* vehicle_sale_and_scrap */}
        <Route path="/vehicle_sale_and_scrap" element={<Vehicle_sale_and_scrap />} />
        <Route path="/vehicle_salescrap/:sno" element={<Vehicle_salescrap />} />
        {/* Inventory */}
        
        <Route path="/inventory/indentNoteView" element={<IntentNoteView />} />
        <Route path="/inventory/addIndentNote" element={<AddIndentNote />} />
        <Route path="/inventory/indentNoteViewSingle/:indentNo" element={<IndentNoteViewSingle />} />
        <Route path="/inventory/modifyIndentNote/:indentNo" element={<ModifyIndentNote />} />
        {/* //Purchase requisition */}
        <Route path="/inventory/purchasesreqView" element={<PurchasesreqView />} />
        <Route path="/inventory/addpr_new" element={<Addpr_new />} />
        <Route path="/inventory/viewpr_new/:prNo" element={<Viewpr_new />} />
        <Route path="/inventory/purchasesreqViewapproval" element={<PurchasesreqViewapproval />} />
        <Route path="/inventory/prApprovalView_Final" element={<PrApprovalView_Final />} />
        <Route path="/inventory/add_PrNew/:fld_purnumber" element={<Add_PrNew />} />
        <Route path="/inventory/prview" element={<Prview />} />
        <Route path="/inventory/prPurchaseReqviewsingle/:priorNo" element={<PrPurchaseReqviewsingle />} />
        <Route path="/inventory/addpriorpurchase_Freight/:priorNo/:scode" element={<Addpriorpurchase_Freight />} />
        <Route path="/inventory/prApprovalView" element={<PrApprovalView />} />
        <Route path="/inventory/prViewSingle/:priorNo" element={<PrViewSinglePage />} />
        <Route path="/inventory/comparisionSupplierWithItemViewsingle/:item" element={<ComparisionSupplierWithItemViewsingle />} />
        <Route path="/inventory/approvedPrList" element={<ApprovedPrList />} />
        <Route path="/inventory/rptPrView" element={<RptPrView />} />
        <Route path="/inventory/viewpr_report/:prNo" element={<Viewpr_report />} />
        <Route path="/inventory/prview_report" element={<Prview_report />} />
        <Route path="/inventory/prViewSinglereport/:prNo" element={<PrViewSinglereport />} />
        <Route path="/inventory/prPurchaseReq30_print/:prNo" element={<PrPurchaseReq30_print />} />
        <Route path="/inventory/purchasesreqdisapproved" element={<Purchasesreqdisapproved />} />
        <Route path="/inventory/viewpr_disapp/:prNo" element={<Viewpr_disapp />} />
        <Route path="/inventory/purchasesreqdisapproved_print" element={<Purchasesreqdisapproved_print />} />
        
        
        
        {/* purchase Order */}
        <Route path="/inventory/purchaseOrderView" element={<PurchaseOrderView />} />
        <Route path="/inventory/addPurchaseOrder" element={<AddPurchaseOrder />} />
        <Route path="/inventory/purchaseorderviewSingle/:poNo" element={<PurchaseorderviewSingle />} />
        <Route path="/inventory/purchaseorderpriview/:poNo" element={<Purchaseorderpriview />} />
        {/* GRN  */}
        <Route path="/inventory/grnmenu" element={<GRNTransactions />} />
        <Route path="/inventory/grnView" element={<GrnView />} />
        <Route path="/inventory/addGrn" element={<AddGrn />} />
        <Route path="/inventory/grnInspection" element={<GrnInspection />} />
        <Route path="/inventory/grnInspectionViewSingle/:grnNo/:poNo" element={<GrnInspectionViewSingle />} />
        <Route path="/inventory/grnConfirm" element={<GrnConfirm />} />
        <Route path="/inventory/grnConfirmViewSingle/:grnNo" element={<GrnConfirmViewSingle />} />
        <Route path="/inventory/grnViewSingle/:grnNo" element={<GrnViewSingle />} />
        <Route path="/inventory/grnReject" element={<GrnReject />} />
        <Route path="/inventory/grnRejectionViewSingle/:grnNo/:poNo/:oldGrn" element={<GrnRejectionViewSingle />} />
        <Route path="/inventory/addgrnRejection" element={<AddgrnRejection />} />
        <Route path="/inventory/rptgrn" element={<Rptgrn />} />
        <Route path="/inventory/grnViewReport" element={<GrnViewReport />} />
        <Route path="/inventory/grnViewSingleReport/:grnNo" element={<GrnViewSingleReport />} />
        <Route path="/inventory/grnRejectionReport" element={<GrnRejectionReport />} />
        <Route path="/inventory/grnRejectionViewSingleReport/:grnNo/:poNo/:oldGrn" element={<GrnRejectionViewSingleReport />} />
        
        
        
        {/* bill Passing menu- HO */}
        <Route path="/inventory/billpassingmenu" element={<Billpassingmenu />} />
        <Route path="/inventory/billPassingGRNView" element={<BillPassingGRNView />} />
        <Route path="/inventory/billpassingGrnViewSingle" element={<BillpassingGrnViewSingle />} />
        <Route path="/inventory/billpassingview/:grnNo" element={<Billpassingview />} />
        <Route path="/inventory/billPassingGrnRejectionView" element={<BillPassingGrnRejectionView />} />
        <Route path="/inventory/billpassinggrnrejview/:grnNo/:oldGrn" element={<Billpassinggrnrejview />} />
        {/* branch office store req */}
        <Route path="/inventory/mis_prview" element={<Mis_prview />} />
        <Route path="/inventory/mis_AddPr" element={<Mis_AddPr />} />
        <Route path="/inventory/mis_PrViewSingle/:prNo/:sNo" element={<Mis_PrViewSingle />} />
        <Route path="/inventory/mis_ModifyPr/:prNo/:sNo" element={<Mis_ModifyPr />} />
        {/* branch office purchase order */}
        <Route path="/inventory/miscPoView" element={<MiscPoView />} />
        <Route path="/inventory/miscPOViewSingle/:poNo" element={<MiscPOViewSingle />} />
        <Route path="/inventory/miscPoView_print/:poNo" element={<MiscPoView_print />} />
        <Route path="/inventory/addMiscPO" element={<AddMiscPO />} />
        <Route path="/inventory/miscPOViewSingle_report/:poNo" element={<MiscPOViewSingle_report />} />
        
        {/* Misc GRN */}
        <Route path="/inventory/miscgrnmenu" element={<Miscgrnmenu />} />
        <Route path="/inventory/miscGrnView" element={<MiscGrnView />} />
        <Route path="/inventory/addMiscGrn" element={<AddMiscGrn />} />
        <Route path="/inventory/miscGrnViewSingle/:grnNo" element={<MiscGrnViewSingle />} />
        <Route path="/inventory/miscGrnInspection" element={<MiscGrnInspection />} />
        <Route path="/inventory/miscGrnInspectionViewSingle/:grnNo" element={<MiscGrnInspectionViewSingle />} />
        <Route path="/inventory/miscgrnRejectionView" element={<MiscgrnRejectionView />} />
        <Route path="/inventory/addMiscGrnRejection" element={<AddMiscGrnRejection />} />
        <Route path="/inventory/miscGrnRejectionViewSingle/:grnNo/:poNo/:oldGrnNo" element={<MiscGrnRejectionViewSingle />} />
        {/* Misc Bill passing menu */}
        <Route path="/inventory/miscbillpassingmenu" element={<Miscbillpassingmenu />} />
        <Route path="/inventory/miscBillPassingGRNView" element={<MiscBillPassingGRNView />} />
        <Route path="/inventory/addbillpassingMiscGrn" element={<AddbillpassingMiscGrn />} />
        <Route path="/inventory/billpassingmiscview/:grnNo" element={<Billpassingmiscview />} />
        <Route path="/inventory/miscBillPassingGrnRejectionView" element={<MiscBillPassingGrnRejectionView />} />
        {/* Delivery Note - Inventory */}
        <Route path="/inventory/delNoteInventory" element={<DelNoteInventory />} />
        <Route path="/inventory/deliveryNote_add_in" element={<DeliveryNote_add_in />} />
        <Route path="/inventory/deliverynoteinward_in/:delNo" element={<Deliverynoteinward_in />} />
        {/* Delivery Note Inward - Inventory */}
        <Route path="/inventory/deliveryinwardnote_in" element={<Deliveryinwardnote_in />} />
        <Route path="/inventory/deliveryNoteInwardReport" element={<DeliveryNoteInwardReport />} />
        <Route path="/inventory/deliverynote_inwardedviewReport/:delNo" element={<Deliverynote_inwardedviewReport />} />
        <Route path="/inventory/deliveryinwardnote_print/:delNo" element={<Deliveryinwardnote_print />} />
        
        {/* DC */}
        <Route path="/inventory/dcView" element={<DcView />} />
        <Route path="/inventory/addDc" element={<AddDc />} />
        <Route path="/inventory/dcViewSingle/:dcNo" element={<DcViewSingle />} />
        <Route path="/inventory/dcPrint/:dcNo" element={<DcPrint />} />
        <Route path="/inventory/dcReturnView" element={<DcReturnView />} />
        <Route path="/inventory/addDcReturn" element={<AddDcReturn />} />
        <Route path="/inventory/dcReturnViewSingle/:dcNo" element={<DcReturnViewSingle />} />
        <Route path="/inventory/dcReturnPrint/:dcNo" element={<DcReturnPrint />} />
        <Route path="/inventory/rptDCpendingView" element={<RptDCpendingView />} />
        <Route path="/inventory/dcNonReturn" element={<DcNonReturn />} />
        
        
        {/* STN */}
        <Route path="/inventory/stn_view" element={<StnView />} />
        <Route path="/inventory/viewstn/:stnNo" element={<StnViewSingle />} />
        <Route path="/inventory/addstn" element={<Addstn />} />
        <Route path="/inventory/addstn_edit/:stnId" element={<Addstn_edit />} />
        <Route path="/inventory/stn_approvalview" element={<Stn_approvalview />} />
        <Route path="/inventory/viewstn_newapproval/:stnId" element={<Viewstn_newapproval />} />
        <Route path="/inventory/addstn_neweditapproval/:stnId" element={<Addstn_neweditapproval />} />
        <Route path="/inventory/stn_disApprovalview" element={<Stn_disApprovalview />} />
        <Route path="/inventory/stnDisApproveView/:stnNo" element={<StnDisApproveView />} />
        <Route path="/inventory/stockTransferNotependingView" element={<StockTransferNotependingView />} />
        <Route path="/inventory/stnInward/:stnNo/:stnBranch" element={<StnInward />} />
        <Route path="/inventory/stnViewpendingSingle/:stnNo/:stnBranch" element={<StnViewpendingSingle />} />
        <Route path="/inventory/stn_inward_reject" element={<Stn_inward_reject />} />
        <Route path="/inventory/stn_inward_rejectView/:stnNo" element={<Stn_inward_rejectView />} />
        <Route path="/inventory/stockTransferNoteView" element={<StockTransferNoteView />} />
        <Route path="/inventory/addStockTransferNote" element={<AddStockTransferNote />} />
        <Route path="/inventory/stnViewSingle/:stnNo/:branch" element={<StnOutwardViewSingle />} />
        <Route path="/inventory/stnViewpendingSinglePrint/:stnNo" element={<StnViewpendingSinglePrint />} />
        <Route path="/inventory/stnViewPendingSingle_report/:stnNo/:stnBranch" element={<StnViewPendingSingle_report />} />
        <Route path="/inventory/stockTransferNoteView_new" element={<StockTransferNoteView_new />} />
        <Route path="/inventory/addStockTransferNote_new" element={<AddStockTransferNote_new />} />
        <Route path="/inventory/stockTransferNote_report" element={<StockTransferNote_report />} />
        <Route path="/inventory/stnReport_print" element={<StnReport_print />} />
        <Route path="/inventory/stnOutward_report" element={<StnOutward_report />} />
        <Route path="/inventory/stnViewOutwardSingle_report/:stnNo/:stnBranch" element={<StnViewOutwardSingle_report />} />
        <Route path="/inventory/stn_outwardreport_print" element={<Stn_outwardreport_print />} />
        <Route path="/inventory/stnRequisitionReport" element={<StnRequisitionReport />} />
        <Route path="/inventory/viewstn_report/:stnNo/:stnBranch" element={<Viewstn_report />} />
        
        
        
        {/* Sf Issues */}
        <Route path="/inventory/sfIssuesView" element={<SfIssuesView />} />
        <Route path="/inventory/addSFissues" element={<AddSFissues />} />
        <Route path="/inventory/sfIssuesViewSingle/:sfNo" element={<SfIssuesViewSingle />} />
        {/* Sf Receipt */}
        <Route path="/inventory/sfReceiptsView" element={<SfReceiptsView />} />
        <Route path="/inventory/addSFReceipts" element={<AddSFReceipts />} />
        <Route path="/inventory/modifySfReceipt/:sfNo" element={<ModifySfReceipt />} />
        <Route path="/inventory/sfReceiptsViewSingle/:sfNo" element={<SfReceiptsViewSingle />} />
        {/* itemMasterViewcomparision */}
        <Route path="/inventory/itemMasterViewcomparision" element={<ItemMasterViewcomparision />} />
        <Route path="/inventory/comparisionSupplierWithItemView/:itemCode" element={<ComparisionSupplierWithItemView />} />
        {/* View Heading */}
        <Route path="/inventory/viewheading" element={<Viewheading />} />
        <Route path="/inventory/viewsubheading/:id" element={<Viewsubheading />} />
        <Route path="/inventory/view_innersubheading/:id/:headingg/:sHeading" element={<View_innersubheading />} />
        <Route path="/inventory/view_Filelisting/:id/:headingg/:sHeading/:innerSHeading" element={<View_Filelisting />} />
        {/* Master Module */}
        <Route path="/inventory/add_Item_Category" element={<Add_Item_Category />} />
        <Route path="/inventory/add_Item_Subcategory/:catCode/:itemName" element={<Add_Item_Subcategory />} />
        <Route path="/inventory/add_Inner_Subcategory/:catCode/:itemName/:subCode/:subItem" element={<Add_Inner_Subcategory />} />
        <Route path="/inventory/add_deep_Inner_Subcategory/:catCode/:itemName/:subCode/:subItem/:innerCode/:innerItem" element={<Add_deep_Inner_Subcategory />} />
        <Route path="/inventory/add_deep_Inner_Item_Subcategory/:catCode/:itemName/:subCode/:subItem/:innerCode/:innerItem/:deepCode/:deepItem" element={<Add_deep_Inner_Item_Subcategory />} />
        {/* Item */}
        <Route path="/inventory/itemmasterviewnew" element={<Itemmasterviewnew />} />
        <Route path="/inventory/addNewItem" element={<AddNewItem />} />
        <Route path="/inventory/modifyitem/:id/:branch" element={<Modifyitem />} />
        <Route path="/inventory/list_Itemserialnumber/:item" element={<List_Itemserialnumber />} />
        <Route path="/inventory/materialclassification" element={<ItemTreeView />} />
        <Route path="/inventory/stock" element={<StockSummary />} />
        <Route path="/inventory/rptItemMasterView" element={<RptItemMasterView />} />
        
        
        {/* Supplier With Item */}
        <Route path="/inventory/supplierMasterView" element={<SupplierMasterView />} />
        <Route path="/inventory/addModifier" element={<AddModifier />} />
        <Route path="/inventory/addNewSupplierWithItem/:sCode/:sName" element={<AddNewSupplierWithItem />} />
        <Route path="/inventory/supplierWIsubassembly" element={<SupplierWIsubassembly />} />
        <Route path="/inventory/supplierWithItemVIew/:sCode/:sName" element={<SupplierWithItemVIew />} />
        <Route path="/inventory/modifySupplierWithItem/:sCode/:sName/:itemCode" element={<ModifySupplierWithItem />} />
        <Route path="/inventory/modifySupplier/:sCode" element={<ModifySupplier />} />
        <Route path="/inventory/modifySupplierView/:sCode" element={<ModifySupplierView />} />
        <Route path="/inventory/supplierMasterViewReport" element={<SupplierMasterViewReport />} />
        <Route path="/inventory/modifySupplierViewReport/:sCode" element={<ModifySupplierViewReport />} />
        <Route path="/inventory/supplierDetailPrint/:sCode" element={<SupplierDetailPrint />} />
        <Route path="/inventory/rptSupplierWithItemView" element={<RptSupplierWithItemView />} />
        {/* Department & Transport*/}
        <Route path="/inventory/departmentMasterView" element={<DepartmentMaster />} />
        <Route path="/inventory/transportMasterView" element={<TransportMasterView />} />
        <Route path="/inventory/subdepartment" element={<Subdepartment />} />
        <Route path="/inventory/uomMasterView" element={<UomMasterView />} />
        {/* PO Report*/}
        <Route path="/inventory/purchaseOrderView_report" element={<PurchaseOrderView_report />} />
        <Route path="/inventory/purchaseOrderViewSingle_report/:poNo" element={<PurchaseOrderViewSingle_report />} />
        <Route path="/inventory/miscpo_report" element={<Miscpo_report />} />
        {/* Ventor Rating */}
        <Route path="/inventory/vendorControlRatingMenu" element={<VendorControlRatingMenu />} />
        <Route path="/inventory/rptVCRqualityGrn" element={<RptVCRqualityGrn />} />
        <Route path="/inventory/rptVCRDeliveryGrn" element={<RptVCRDeliveryGrn />} />
        <Route path="/inventory/rptSupplierRatingGrn" element={<RptSupplierRatingGrn />} />


   {/*///////////////Admin///////////*/}
   <Route path="/admin/admin_members_list" element={<Admin_members_list />} />
   <Route path="/admin/admin_members_add" element={<Admin_members_add />} />
   <Route path="/admin/admin_members_edit/:memId" element={<Admin_members_edit />} />
   <Route path="/admin/admin_members_approval/:memId" element={<Admin_members_approval />} />
    {/*Category*/}
    <Route path="/admin/staff_category_list" element={<Staff_category_list />} />
     {/*Flash News*/}
     <Route path="/admin/flashnewslist" element={<Flashnewslist />} />
     <Route path="/admin/flashNewsEntry" element={<FlashNewsEntry />} />
     <Route path="/admin/flashNewsEdit/:id" element={<FlashNewsEdit />} />
     {/*Add File heading*/}
     <Route path="/admin/add_fileheading" element={<Add_fileheading />} />
     <Route path="/admin/add_filesubheading/:id/:heading" element={<Add_filesubheading />} />
     <Route path="/admin/add_filesubheadingsecond/:id/:heading/:subHeading" element={<Add_filesubheadingsecond />} />
      {/*Add File heading*/}
      <Route path="/admin/branchMasterView" element={<BranchMasterViewAdmin />} />
       {/*Admin Menu*/}
       <Route path="/admin/admin_Menu" element={<Admin_Menu />} />
       <Route path="/admin/admin_menu_add" element={<Admin_menu_add />} />
       <Route path="/admin/admin_Menu_edit/:sNo" element={<Admin_Menu_edit />} />
       <Route path="/admin/menu_orders" element={<Admin_Menu_orders />} />
       <Route path="/admin/cd" element={<Cd />} />
             
          <Route path="/admin/admin_filemanager" element={<FileManager />} />
        <Route path="/admin/file_listing" element={<FileListing />} />
        <Route path="/admin/add_newfile" element={<AddNewFile />} />
        <Route path="/admin/file_edit/:sNo" element={<File_Edit />} />
       
  
        
       
          <Route path="*" element={<NotFound />} />
        
        </Routes>
      </Router>
    </div>
  );
}

export default App;

